import { config } from '../configuration/config';

export const MODULE_NAME = 'SmartRoute';

export const BBOX_OFFSET = 0.1;
export const SINGLE_ASSET_ZOOM = 18;
export const POWER_LOW = 150; // in kW
export const POWER_MEDIUM = 350; // in kW
export const POWER_HIGH = 750; // in kW

export const Unit = {
    KWH: 'kWh',
    kW: 'kW',
    currency: '€',
    weight: 'kg',
    km: 'km',
    m: 'm',
    pct: '%',
};

export enum ROUTE {
    ROOT_ROUTE = '/',
    SEARCH_ROUTE = '/search',
    DETAILS_ROOT_ROUTE = '/details',
    CLUSTER_ROUTE = '/details/cluster',
    DETAILS_ROUTE = '/details/:id',
}

export const STORE_BASE_PATH = `${config.serviceName}/`;

export const MarketplaceSettings = {
    URL: config.backend.MARKETPLACE_SERVICE,
    BUY_BUTTON_URL: config.backend.MARKETPLACE_BUY_BUTTON_SERVICE,
    srpProductId: 'man-sku00000085',
    cgProductId: 'man-sku00000093',
    defaultLevel: '10',
    srpInternalCampaign: 'charging-station-widget-man-smart-route-upselling',
    cgInternalCampaign: 'charging-station-widget-man-charge-and-go-upselling',
    manchargego: 'https://manchargego.rio.cloud/',
};

export const API = {
    serviceName: 'smart-route-web-api',
    version: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
    },
    endpoints: {
        accountSubscription: '/account/subscription',
        chargePoints: '/charging-station/list',
        chargingStations: '/charging-stations',
        chargingCluster: '/charging-stations/cluster',
        featureToggles: '/feature-toggles',
        details: '/details',
        metadata: '/metadata',
    },
    parameters: {
        limit: 1000,
        chunk: 200,
    },
};

export const BASE_URL_V2 = `${config.backend.BACKEND_DOMAIN}/${API.serviceName}/${API.version.v2}`;
export const BASE_URL_V3 = `${config.backend.BACKEND_DOMAIN}/${API.serviceName}/${API.version.v3}`;
